import React from "react";
import * as Scroll from "react-scroll";
// import khalaq1 from "https://ebus.ir/service/docs/khalaq1.jpg"
// import khalaq2 from "https://ebus.ir/service/docs/khalaq1.jpg"

const Khalaq = () => {

    let scroll = Scroll.animateScroll;

    React.useEffect(() => {
        scroll.scrollToTop();
    }, []);

    return (
        <div className="d-flex justify-content-center mt-15">
            <img
                className="w-50 h-50"
                src={`https://ebus.ir/service/docs/certificate_khalaq1.jpg`}
                alt="miras1"
            />
            <img
                className="w-50 h-50"
                src={`https://ebus.ir/service/docs/certificate_khalaq2.jpg`}
                alt="miras2"
            />
        </div>
    )
}

export default Khalaq